import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { removeMessageFromMessageBody, toggleModal, toggleModalWithTimer, updateMessages } from 'apps/promo/actions/appAction';
import { InfoPage } from 'apps/promo/components/common/Layout/InfoPage/InfoPage';
import PromoModalComponent from 'apps/promo/components/utils/PromoModalComponent';
import { CHANGE_IDENT_STATUS, ERROR, ERROR_TOAST, INFO, SUCCESS, SUCCESS_TOAST } from 'apps/promo/constants/Constants';
import { AUTH_CLOSE_MESSAGE_URL } from 'apps/promo/constants/UrlConstants';
import { getFullEncodeApiUrl } from 'apps/promo/helpers/api';
import { logWarn } from 'apps/promo/helpers/clientLogger';
import { isSoftOrHardServerError } from 'apps/promo/helpers/utils';

const MESSAGE_CLOSE_ACTION = '/message/close.action';

const removingUnnecessaryMessages = ({ messages, ...props }) => {
    const requests = [];
    const lastIndexArray = messages.length - 1;
    messages.forEach((element, index) => {
        const { expires, messageId, messageType } = element;
        const isTypeMessageError = messageType === ERROR || messageType === ERROR_TOAST;
        const isTypeMessageSuccess = messageType === SUCCESS || messageType === SUCCESS_TOAST;
        const isNotLastElement = lastIndexArray !== index;
        if ((isTypeMessageError || isTypeMessageSuccess) && isNotLastElement) {
            requests.push(
                fetch(getFullEncodeApiUrl(`${props.isAuth ? AUTH_CLOSE_MESSAGE_URL : MESSAGE_CLOSE_ACTION}?messageId=${messageId}&expire${expires}`), {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    body: new URLSearchParams(),
                    headers: { Accept: 'application/json' },
                }),
            );
        }
    });
    if (requests.length > 0) {
        Promise.allSettled(requests)
            .then((responses) => Promise.allSettled(responses.map((r) => r.value.text())))
            .then((res) => {
                if (res.length === lastIndexArray) {
                    props.updateMessages([messages[lastIndexArray]]);
                }
            })
            .catch((err) => {
                logWarn(err);
                return null;
            });
    }
};

const MessageBodyService = (props) => {
    const { messages = [] } = props;

    useEffect(() => {
        if (messages?.length > 1) {
            removingUnnecessaryMessages(props);
        }
    }, [messages?.length]);

    useEffect(() => {
        if (messages?.length) {
            messages.forEach((message) => showModal(message));
        }
    }, [messages]);

    const showModal = (message) => {
        const { expires, messageId, messageType, value, errorCode } = message;
        const isTypeMessageError = messageType === ERROR || messageType === ERROR_TOAST;
        const isTypeMessageSuccess = messageType === SUCCESS || messageType === SUCCESS_TOAST;
        const isTypeMessageInfo = messageType === INFO;
        const softOrHardBlock = isSoftOrHardServerError(errorCode);

        if (!softOrHardBlock) {
            if (isTypeMessageSuccess || isTypeMessageInfo) {
                props.toggleModalWithTimer(true, value, () => {
                    props.removeMessageFromMessageBody(messageId, expires, props.isAuth);
                    props.toggleModalWithTimer(false);
                });
            }
            if (isTypeMessageError) {
                props.toggleModal(
                    true,
                    <PromoModalComponent canCloseModal={false} isVerticalCentered key={messageId}>
                        <InfoPage
                            insideModalComponent
                            animatedIconFail
                            mainText={value}
                            primaryButtonType="button"
                            primaryButtonCaption={props.goBack}
                            primaryButtonOnClick={() => {
                                props.toggleModal(false);
                                props.removeMessageFromMessageBody(messageId, expires, props.isAuth);
                            }}
                        />
                    </PromoModalComponent>,
                );
            }
        }
        return null;
    };

    return null;
};

MessageBodyService.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            messageId: PropTypes.string.isRequired,
            messageType: PropTypes.oneOf([SUCCESS, INFO, ERROR, SUCCESS_TOAST, CHANGE_IDENT_STATUS, ERROR_TOAST]).isRequired,
            expires: PropTypes.number,
        }),
    ),
};

const mapStateToProps = (state) => {
    return {
        isAuth: state.auth.authUser,
        messages: state.app.messageBody,
        goBack: state.messages.pageMessages.goBack,
    };
};

export default connect(mapStateToProps, { removeMessageFromMessageBody, updateMessages, toggleModal, toggleModalWithTimer })(MessageBodyService);
